"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _jsxRuntime = require("react/jsx-runtime");

var _default = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8 4v12h12V4H8zm6.74 10.69c-.2.21-.44.31-.73.31s-.54-.1-.74-.31c-.21-.21-.31-.45-.31-.74s.1-.54.31-.74c.21-.2.45-.3.74-.3s.54.1.74.3c.2.2.3.45.3.74s-.11.54-.31.74zm1.77-5.86c-.23.34-.54.69-.92 1.06-.3.27-.51.52-.64.75-.12.23-.18.49-.18.78v.4h-1.52v-.56c0-.42.09-.78.26-1.09.18-.32.49-.67.95-1.07.32-.29.55-.54.69-.74.14-.2.21-.44.21-.72 0-.36-.12-.65-.36-.87-.24-.23-.57-.34-.99-.34-.4 0-.72.12-.97.36s-.42.53-.53.87l-1.37-.57c.18-.55.52-1.03 1-1.45.49-.43 1.11-.64 1.85-.64.56 0 1.05.11 1.49.33.44.22.78.53 1.02.93s.36.84.36 1.33c0 .49-.11.9-.35 1.24z",
  opacity: ".3"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-6.49-5.84c.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C11.51 5.96 12.52 5 13.99 5c1.23 0 2.08.56 2.51 1.26.37.6.58 1.73.01 2.57-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c.01-.41-.06-1.08.26-1.66zm-.56 3.79c0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04 0 .58-.44 1.05-1.04 1.05-.58 0-1.05-.47-1.05-1.05z"
}, "1")], 'QuizTwoTone');

exports.default = _default;